import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from "@material-ui/core";
import { Button } from "components/Forms/StyledComponents";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import { LoadError } from "./LoadError";

export default function LoadErrorDialog({ error }: { error: LoadError }) {
  const { t } = useTranslation(["templateDefinitions", "rules"]);
  const history = useHistory();

  return (
    <Dialog open data-testid="accounts-error-dialog">
      <DialogTitle>{t("accountsWarning.title")}</DialogTitle>
      <DialogContent>
        <Typography variant="body2" color="textSecondary">
          {error === "NO_ACCOUNTS_ENABLED" && t("accountsWarning.content")}
          {error === "NO_BOX_ACCOUNTS" &&
            t("accountsWarning.noAccountByType", {
              storageType: "Box",
            })}
          {error === "NO_EGNYTE_ACCOUNTS" &&
            t("accountsWarning.noAccountByType", {
              storageType: "Egnyte",
            })}
        </Typography>
      </DialogContent>
      <DialogActions style={{ marginTop: "15px", marginBottom: "5px" }}>
        <Button
          variant="outlined"
          size="small"
          wording={t("common:backToList")}
          onClick={() => history.push("/template-definitions")}
          data-testid="back-to-list-button"
        />
        <Button
          size="small"
          wording={t("error.noAccounts.action")}
          onClick={() => history.push("/integrations?tab=ACCOUNTS")}
          data-testid="go-to-integrations-button"
        />
      </DialogActions>
    </Dialog>
  );
}
